import axios from 'axios';

const getAllDrivers = () => axios.get(`/payments/all`);

export { getAllDrivers };
